import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  ImageListItem,
  ImageListItemBar,
  Tooltip,
} from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  getFaceWithNameLink,
  getStreamingTitleWithLink,
  MemberInfo,
} from "../common/common";
import ResultBar from "./ResultBar";

type Props = {
  videoId: string;
  url: string;
  w: number;
  h: number;
  title: string;
  channelTitle: string;
  channelId: string;
  startTime: string;
  timeOfDay: string;
  memberList: MemberInfo[];
};
function StreamingItem(props: Props) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [resultBarOpen, setResultBarOpen] = useState(false);

  const {
    videoId,
    channelTitle,
    timeOfDay,
    title,
    url,
    w,
    h,
    startTime,
    channelId,
    memberList,
  } = props;

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleCopy = () => {
    setResultBarOpen(true);
  };

  const handleResultBarClose = () => {
    setResultBarOpen(false);
  };

  const videoUrl = `https://youtube.com/watch?v=${videoId}`;

  let streamerName = "UNKNOWN";
  memberList.forEach((member) => {
    if (member.channel === channelId) {
      streamerName = member.name;
    }
  });
  const resultText = `${timeOfDay}- ${getFaceWithNameLink(
    streamerName
  )} ${getStreamingTitleWithLink(title, videoUrl)}`;

  return (
    <ImageListItem>
      <a href={videoUrl}>
        <img src={url} width={w} height={h} alt={title} />
      </a>
      <ImageListItemBar
        title={title}
        subtitle={`@${channelTitle} | Scheduled at ${startTime}-`}
        actionIcon={
          <Tooltip title="クリックしてぶいすぽ非公式wiki用の構文を生成">
            <IconButton
              sx={{ color: "rgba(255, 255, 255, 0.8)" }}
              onClick={handleClick}
              aria-label={videoId}
            >
              <TodayIcon />
            </IconButton>
          </Tooltip>
        }
      />
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>
          ぶいすぽ非公式wiki配信スケジュールページ用構文
        </DialogTitle>
        <DialogContent>
          <Tooltip title="文字列をクリックしてクリップボードにコピー">
            <div>
              <CopyToClipboard text={resultText} onCopy={handleCopy}>
                <div>{resultText}</div>
              </CopyToClipboard>
            </div>
          </Tooltip>
        </DialogContent>
        <ResultBar
          open={resultBarOpen}
          result={title}
          handleClose={handleResultBarClose}
          successMessage="クリップボードにコピーしました"
          errorMessage="配信タイトルが設定されていません。配信URLを確認して下さい"
        />
      </Dialog>
    </ImageListItem>
  );
}

export default StreamingItem;
